// extracted by mini-css-extract-plugin
export var actionIcon = "_sc-0";